import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import './styles.scss'
import { SIZE_INFO } from '../../../helpers/utils'

const DiaperSizeGuide = () => {
  const { t } = useTranslation()
  return (
    <div className='diaper-size-guide'>
      <img
        className='diaper-size-guide-bg-img-1'
        src={t('diaperSizeGuide:bg-img-1-src')}
        alt={t('diaperSizeGuide:bg-img-1-alt')}
        height='165'
        loading='lazy'
      />
      <h1 className='title mt-32 💻mt-32' dangerouslySetInnerHTML={{ __html: t('diaperSizeGuide:title') }} />
      <p className='subtitle' dangerouslySetInnerHTML={{ __html: t('diaperSizeGuide:subtitle') }} />
      <br />
      <p dangerouslySetInnerHTML={{ __html: t('diaperSizeGuide:text1') }} />
      <br />
      <div className='size-list'>
        {SIZE_INFO.diapers.map((sizeInfos, index) =>
          <div key={index} className={classNames('size-container', { grayBackground: index % 2 !== 0 })}>
            <div dangerouslySetInnerHTML={{ __html: t('diaperSizeGuide:weight', { min: sizeInfos.weightRange[0], max: sizeInfos.weightRange[1] }) }} />
            <div>{t('diaperSizeGuide:size', { size: sizeInfos.index })}</div>
          </div>
        )}
      </div>
      <p className='mt-32 💻mt-32 mb-32 💻mb-32' dangerouslySetInnerHTML={{ __html: t('diaperSizeGuide:text2') }} />
      <img
        className='diaper-size-guide-bg-img-2'
        src={t('diaperSizeGuide:bg-img-2-src')}
        alt={t('diaperSizeGuide:bg-img-2-alt')}
        height='300'
        loading='lazy'
      />
      <p className='white-shadowed-content' dangerouslySetInnerHTML={{ __html: t('diaperSizeGuide:text3') }} />
    </div>
  )
}

export default DiaperSizeGuide
